export class ClockWorkSettingRequestModel {
    constructor() {
        this.taskId = "";
        this.isClockWorkSetWeeklyMail = false;
        this.isWFO = false;
        this.fromSettings = true;
    }
}
export default class ClockWorkSettingRequest extends ClockWorkSettingRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
